export const generateNewsImportItems = () => {
    const templateMenuItems = [
        {
            name: 'News in English',
            description: 'NYT, The Guardian, FT, etc.',

            type: 'news-en',
            content: [
                'https://www.theguardian.com/world/rss',
                'https://feeds.a.dj.com/rss/RSSWorldNews.xml',
                'http://rss.nytimes.com/services/xml/rss/nyt/World.xml',
                'http://feeds.washingtonpost.com/rss/world',
                'https://www.ft.com/?format=rss',
            ],
        },
        {
            name: 'News in French',
            description: 'Le Monde, BFM, Le Figaro, etc.',

            type: 'news-fr',
            content: [
                'http://www.lemonde.fr/rss/une.xml',
                'https://www.bfmtv.com/rss/news-24-7/',
                'http://www.lefigaro.fr/rss/figaro_actualites.xml',
                'http://rss.liberation.fr/rss/latest/',
                'https://feeds.leparisien.fr/leparisien/rss/faits-divers',
            ],
        },
        {
            name: 'News in German',
            description: 'FAZ, TAX, Welt, Tagespiegel',

            type: 'news-de',
            content: [
                'http://www.faz.net/rss/aktuell/',
                'https://www.welt.de/feeds/latest.rss',
                'https://www.tagesspiegel.de/contentexport/feed/home',
                'http://www.taz.de/!p15;rss/',
            ],
        },
        {
            name: 'News in Russian',
            description: 'Vedomosti, RBC, Kommersant, etc.',

            type: 'news-ru',
            content: [
                'https://www.vedomosti.ru/rss/news',
                'https://meduza.io/rss/all',
                'https://rssexport.rbc.ru/rbcnews/news/30/full.rss',
            ],
        },
        {
            name: 'News in Chinese',
            description: 'China News and other newspapers',

            type: 'news-cn',
            content: [
                'https://rss.feedspot.com/folder/4xrGt2Ae6Q==/rss/rsscombiner',
            ],
        },
        {
            name: 'Tech News',
            description: 'News on technology and startups',

            type: 'news-tech',
            content: [
                'http://feeds.feedburner.com/TechCrunch',
                'https://www.technologyreview.com/topnews.rss',
                'http://feeds.arstechnica.com/arstechnica/technology-lab',
                'http://feeds.feedburner.com/venturebeat/SZYF',
            ],
        },
        {
            name: 'Energy News',
            description: 'News on energy and climate',

            type: 'news-energy',
            content: ['https://rss.app/feeds/t0b3Szvg274ZWwAl.xml'],
        },
        {
            name: 'Crypto News',
            description: 'News on crypto and blockchain',

            type: 'news-crypto',
            content: ['https://rss.app/feeds/tVpkAbmLQkpiiL7c.xml'],
        },
        {
            name: 'The Financial Times',
            description: 'The Financial Times newsfeed',

            type: 'news-financial-times',
            content: ['https://www.ft.com/?format=rss'],
        },
        {
            name: 'The New York Times',
            description: 'The New York times newsfeed',

            type: 'news-nyt',
            content: ['http://rss.nytimes.com/services/xml/rss/nyt/World.xml'],
        },
        {
            name: 'Add Your Own Feeds',
            description: 'Analyze any RSS feeds',

            type: 'news-rss',
            content: [],
        },
    ]
    return templateMenuItems
}
